export default "__VITE_ASSET__3ea4912b__"